/**
 * User-facing copy for sync indicator (no Firestore jargon).
 */

/** @typedef {import('./syncState').SyncPhase} SyncPhase */

/**
 * @param {SyncPhase | 'synced'} phase
 * @returns {string}
 */
export function syncPhaseLabel(phase) {
  switch (phase) {
    case "live":
      return "Live";
    case "offline":
      return "Offline";
    case "connecting":
      return "Reconnecting…";
    case "saving":
      return "Saving…";
    case "waiting_to_sync":
      return "Waiting to sync";
    case "synced":
      return "Synced";
    case "error":
      return "Sync unavailable";
    default:
      return "";
  }
}

/**
 * @param {SyncPhase | 'synced'} phase
 * @returns {string}
 */
export function syncPhaseHint(phase) {
  if (phase === "waiting_to_sync" || phase === "saving") {
    return "Updates waiting";
  }
  return "";
}

/**
 * @param {SyncPhase | 'synced'} phase
 * @returns {'success' | 'warn' | 'danger' | 'muted' | 'neutral'}
 */
export function syncPhaseTone(phase) {
  switch (phase) {
    case "live":
    case "synced":
      return "success";
    case "saving":
    case "connecting":
      return "warn";
    case "offline":
    case "waiting_to_sync":
      return "danger";
    case "error":
      return "danger";
    default:
      return "neutral";
  }
}
